/**
 * Idempotentlik kalitining umri — SOF mantiq, komponentdan ajratilgan.
 *
 * ⛔ Bu ajratish bezak emas. `ConfirmAction` ichida turganda mantiqni
 * faqat MATN bo'yicha tekshirish mumkin edi va 2026-08-20 auditi buni
 * chetlab o'tdi: `{ seed, key }` ni `{ seed: '', key }` ga o'zgartirsa
 * kalit har renderda qaytadan yasalardi (nuqson to'liq qaytardi), test
 * esa 10/10 yashil qolardi. Endi qorovul funksiyaning O'ZINI chaqiradi.
 *
 * Ikki talab birga bajarilishi SHART:
 *   · o'sha `seed` -> O'SHA kalit, tasdiq necha marta yopilib ochilsa ham
 *     (qayta urinish server uchun TAKROR bo'lsin, ikkinchi to'lov emas);
 *   · `seed` o'zgardi -> YANGI kalit (haqiqiy ikkinchi to'lov jimgina
 *     "dublikat" deb rad etilmasin).
 */
export interface KeyHolder {
  seed: string
  key: string
}

/**
 * Saqlangan kalitni qaytaradi yoki `seed` o'zgargan bo'lsa yangisini
 * yasaydi.
 *
 * @param held saqlangan holat; birinchi chaqiruvda `null`
 * @param seed amal barmog'i — nishon + summa
 * @param make yangi kalit yasovchi
 */
export function rememberKey(
  held: KeyHolder | null,
  seed: string,
  make: () => string,
): KeyHolder {
  if (held !== null && held.seed === seed) return held
  return { seed, key: make() }
}
